var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowAltCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.09585216,3.06726912 C0.09585216,1.42580088 1.42580088,0.09585216 3.06726912,0.09585216 C4.70873736,0.09585216 6.03868608,1.42580088 6.03868608,3.06726912 C6.03868608,4.70873736 4.70873736,6.03868608 3.06726912,6.03868608 C1.42580088,6.03868608 0.09585216,4.70873736 0.09585216,3.06726912 Z M3.594456,4.45712544 L3.594456,3.06726912 L4.44394577,3.06726912 C4.57214803,3.06726912 4.63684824,2.91150936 4.54578869,2.82164796 L3.16911204,1.45216022 C3.1127989,1.39584708 3.0229375,1.39584708 2.96662435,1.45216022 L1.58874955,2.82164796 C1.49769,2.91270751 1.56239021,3.06726912 1.69059247,3.06726912 L2.54008224,3.06726912 L2.54008224,4.45712544 C2.54008224,4.53620347 2.60478245,4.60090368 2.68386048,4.60090368 L3.45067776,4.60090368 C3.52975579,4.60090368 3.594456,4.53620347 3.594456,4.45712544 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowAltCircleUp);
export default __webpack_public_path__ + "static/media/arrow-alt-circle-up.8c67d67ba13928f76515a5e0de5d7291.svg";
export { ForwardRef as ReactComponent };